import BaseVM from './base-vm';

class InfoViewModel {
  constructor() { this.init.apply(this, arguments); }
}

InfoViewModel.prototype = Kadenze.Util.extendClass(BaseVM, {
  remove_logo: ko.observable(false),

  init (data, wizard) {
    var self = this;

    this.super('init', wizard, data);

    this.mapping = {
      forum_settings: {
        update: (options) => {
          var vm = ko.mapping.fromJS(options.data);
          vm.name.extend({notify: 'always'});
          vm.computed_name = ko.computed({
            read: () => {
              return vm.name() || `${options.parent.order()}: ${options.parent.title() || '[Title]'}`;
            },
            write: (value) => {
              vm.name(value);
            }
          }).extend({notify: 'always'});
          return vm;
        }
      }
    };


    // Map all properties to 'this' object
    ko.mapping.fromJS(data, this.mapping, this);

    // Validations
    this.title.extend({ required: { message: 'Title is required' } });
    this.description.extend({ required: { message: 'Synopsis is required' } });

    // for the publish panel summary
    this.hasImage = ko.computed(function() {
      return self.logo_path() ? 'Yes' : 'No';
    });
  },

  initUI () {
    this.initLogoDropzone();
    this.initialized = true;
  },

  initLogoDropzone () {
    var self = this;
    var curFileObj, message, options, callbacks,
      $el = $('#session-img-dz'),
      uploadURL = Kadenze.Routes.temp_image_upload_path();

    message = JST['templates/dropzone-generic']({
      title: Kadenze.I18n.t('drop_file_editor.session_image_title', 'en'),
      maxFilesize: 10,
      acceptedFiles: '.jpg, .png',
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    });

    options = {
      dzName: 'Session Image',
      dzPreview: JST['templates/dropzone-generic-img-preview']({
        previewable: true,
        containerClass: 'dz-preview-wide',
        nameLabel: Kadenze.I18n.t('file_preview.name'),
        sizeLabel: Kadenze.I18n.t('file_preview.size'),
        previewLabel: Kadenze.I18n.t('file_preview.preview'),
        removeLabel: Kadenze.I18n.t('file_preview.remove_file'),
        fileUploadProgressLabel: Kadenze.I18n.t('file_preview.file_upload_progress')
      }),
      previewable: true,
      maxFilesize: 10,
      acceptedFiles: '.jpg, .jpeg, .png',
      cropOptions: {
        modalId: 'crop_modal'
      },
      autoProcessQueue: false
    };

    callbacks = {
      success: (file, response) => {
        self.logo_path(response.path);
        self.remove_logo(false);
      },
      error: (file, errorMessage) => {
        new Kadenze.Notice.error( { message: Kadenze.I18n.t('drop_file_editor.file_not_supported') } );
      },
      removedfile: (file) => {
        self.remove_logo(true);
        self.logo_path('');
      }
    };

    curFileObj = {
      name: self.logo_file_name(),
      size: self.logo_file_size(),
      path: self.logo.url()
    };

    this.dropZone = new Kadenze.ImageDropZone($el, message, uploadURL, callbacks, curFileObj, options);
  },

  getSummary () {
    return {
      id: 1, // allow's KO to update items correctly
      heading: Kadenze.I18n.t('session.publish_summary.session_info.heading'),
      overviewItems: this.getOverviewItems()
    };
  },

  getOverviewItems () {

    var title_label = Kadenze.I18n.t('session.publish_summary.session_info.title_lable');
    var image_label = Kadenze.I18n.t('session.publish_summary.session_info.image_label');
    var visible_label = Kadenze.I18n.t('session.publish_summary.session_info.visible_label');
    var meeting_start = Kadenze.I18n.t('session.publish_summary.session_info.meeting_start_label');
    var meeting_end = Kadenze.I18n.t('session.publish_summary.session_info.meeting_end_label');


    if(this.adaptive()) {
      return [
        { title: `${title_label} :`, description: this.title },
        { title: `${image_label}`, description: this.hasImage  }
      ];
    } else if (Kadenze.isKadenze) {
      return [
        { title: `${title_label} :` , description: this.title },
        { title: `${visible_label}`, description: this.wizard.publishPanel.visible_on },
        { title: `${image_label} :`, description: this.hasImage  }
      ];
    } else {
      return [
        { title: `${title_label} :`, description: this.title },
        { title: `${visible_label}`, description: this.wizard.publishPanel.visible_on },
        { title: `${meeting_start}`, description: this.wizard.publishPanel.start_date },
        { title: `${meeting_end}`, description: this.wizard.publishPanel.end_date },
        { title: `${image_label}`, description: this.hasImage  }
      ];
    }
  }

});
export default InfoViewModel;



